import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';


const ITEM_HEIGHT = 50;

export default function LongMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelection = (value) => {
    setAnchorEl(null);
    props.onClick(value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: (props.width) ? props.width : 150,
            marginTop: 50,
          },
        }}
      >
        {props.list.map((option, index) => (
          <MenuItem className="text-center root" key={index}  onClick={()=>handleSelection(option)} >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}


/*
Implementation example:
  <MenuIcon
    list={menuOptions}
    onClick={(value) => handleProgramSelection(value, data.programID)}
    width="187" 
  />
*/